import { Injectable } from '@angular/core';
import { Observable, catchError, of, timeout } from 'rxjs';
import { AddressValidationRequestI, AddressValidationResultI } from '@bodyanalytics/data-models-ui';
import { BaseHttpCrudService } from '../../+http/base-http-crud.service';
import { ApiLocalRoutesEnum } from '../../enums/api-routes.enum';

/** Emitted whenever the check cannot be performed — callers must treat it as "proceed". */
export const ADDRESS_VALIDATION_ERROR: AddressValidationResultI = { verdict: 'ERROR' };

/** Client-side cap so a slow provider never holds the submit button hostage. */
const CLIENT_TIMEOUT_MS = 5000;

/**
 * Thin client for `POST /address/validate` (address-validation-api). Fail-open
 * by contract: any HTTP error, timeout, or malformed payload resolves to
 * `{ verdict: 'ERROR' }` so the calling form can submit without the hint.
 */
@Injectable({ providedIn: 'root' })
export class AddressValidationService extends BaseHttpCrudService {
  validate(address: AddressValidationRequestI): Observable<AddressValidationResultI> {
    return this.postResource<AddressValidationResultI>(ApiLocalRoutesEnum.API_SUFFIX_ADDRESS_VALIDATE, address, {
      op: 'validateAddress',
      fallback: ADDRESS_VALIDATION_ERROR,
    }).pipe(
      timeout(CLIENT_TIMEOUT_MS),
      catchError(() => of(ADDRESS_VALIDATION_ERROR)),
    );
  }
}
